<div class="error-page">
    <div class="wrap">
        <span class="info-text">Pro tuto stránku nemáte oprávnění</span>
        <div class="error-code">
            401
        </div>
        <span class="links">
            <a (click)="goBack()">Vrátit se na zpět</a>
            <a routerLink="/landingPage">Vrátit se na úvod</a>
        </span>
    </div>
</div>